import styled from 'styled-components';

export const PageContainer = styled.div`
  min-height: calc(100vh - 64px);
  background-color: #f5f5f5;
`;

export const Header = styled.div`
  background-color: #fff;
  border-bottom: 1px solid #e8e8e8;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    gap: 12px;
  }
`;

export const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const HeaderTitle = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  margin: 0;
`;

export const HeaderButtons = styled.div`
  display: flex;
  gap: 12px;

  @media (max-width: 768px) {
    width: 100%;

    button {
      flex: 1;
    }
  }
`;

export const Btn = styled.button<{ $primary?: boolean; $danger?: boolean }>`
  padding: 8px 16px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: all 0.3s;
  border: ${(props) => (props.$primary || props.$danger ? 'none' : '1px solid #d9d9d9')};
  background-color: ${(props) => (props.$primary ? '#1890ff' : props.$danger ? '#ff4d4f' : '#fff')};
  color: ${(props) => (props.$primary || props.$danger ? '#fff' : '#262626')};

  &:hover {
    background-color: ${(props) => (props.$primary ? '#40a9ff' : props.$danger ? '#ff7875' : '#fafafa')};
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Content = styled.div`
  display: flex;
  height: calc(100vh - 137px);

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
  }
`;

export const LeftPanel = styled.div`
  width: 50%;
  padding: 24px;
  overflow: auto;

  @media (max-width: 768px) {
    width: 100%;
    overflow: visible;
  }
`;

export const RightPanel = styled.div`
  width: 50%;
  background-color: #fff;
  border-left: 1px solid #e8e8e8;
  display: flex;
  flex-direction: column;

  @media (max-width: 768px) {
    width: 100%;
    border-left: none;
    border-top: 1px solid #e8e8e8;
    min-height: 500px;
  }
`;

export const Card = styled.div`
  background-color: #fff;
  border-radius: 8px;
  border: 1px solid #e8e8e8;
  padding: 24px;
  margin-bottom: 24px;
`;

export const BarcodeContainer = styled.div`
  display: flex;
  gap: 32px;
  margin-bottom: 24px;

  @media (max-width: 1024px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const BarcodeIcon = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const InfoSection = styled.div`
  flex: 1;
`;

export const InfoTitle = styled.h3`
  font-size: 14px;
  font-weight: 600;
  color: #262626;
  margin-bottom: 12px;
`;

export const InfoItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const InfoIcon = styled.div<{ $color?: string }>`
  flex-shrink: 0;
  margin-top: 2px;
  color: ${(props) => props.$color || '#8c8c8c'};
`;

export const InfoContent = styled.div`
  flex: 1;
`;

export const InfoLabel = styled.p`
  font-size: 12px;
  color: #8c8c8c;
  margin: 0;
`;

export const InfoValue = styled.p`
  font-size: 14px;
  font-weight: 500;
  color: #262626;
  margin: 0;
`;

export const InfoExtra = styled.p`
  font-size: 12px;
  color: ${(props) => props.color || '#8c8c8c'};
  margin: 4px 0 0 0;
`;

export const TextInput = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #d9d9d9;
  border-radius: 6px;
  font-size: 14px;
  transition: all 0.3s;

  &:focus {
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
    outline: none;
  }
`;

export const LastScanned = styled.div`
  margin-top: 12px;
  padding: 12px;
  background-color: #fafafa;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const LastScannedLabel = styled.span`
  font-size: 12px;
  color: #8c8c8c;
`;

export const LastScannedValue = styled.span`
  font-family: 'Courier New', monospace;
  font-size: 14px;
  font-weight: 600;
  color: #262626;
`;

export const StatCard = styled(Card)`
  padding: 20px;
`;

export const StatGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-top: 16px;

  @media (max-width: 576px) {
    grid-template-columns: 1fr;
  }
`;

export const StatLabel = styled.p`
  font-size: 12px;
  color: #8c8c8c;
  margin: 0 0 4px 0;
`;

export const StatValue = styled.p<{ $color?: string }>`
  font-size: 32px;
  font-weight: 600;
  color: ${(props) => props.$color || '#262626'};
  margin: 0;
`;

export const StatIcon = styled.div<{ $bgColor?: string; $color?: string }>`
  width: 48px;
  height: 48px;
  border-radius: 8px;
  background-color: ${(props) => props.$bgColor || '#f0f0f0'};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.$color || '#8c8c8c'};
  font-size: 24px;
`;

export const Note = styled.div`
  padding: 16px;
  background-color: #e6f7ff;
  border: 1px solid #91d5ff;
  border-radius: 6px;

  p {
    margin: 0;
    font-size: 14px;
    color: #0050b3;

    strong {
      font-weight: 600;
    }
  }
`;

export const RightHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: space-between;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
`;

export const RightTitle = styled.h2`
  font-size: 18px;
  font-weight: 600;
  color: #262626;
  margin: 0;
`;

export const RightSubtitle = styled.p`
  font-size: 14px;
  color: #8c8c8c;
  margin: 0;
`;

export const EmptyState = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px;
`;

export const EmptyIcon = styled.div`
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background-color: #f5f5f5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
  font-size: 48px;
  color: #bfbfbf;
`;

export const EmptyTitle = styled.p`
  font-size: 16px;
  color: #595959;
  margin: 0 0 8px 0;
`;

export const EmptySubtitle = styled.p`
  font-size: 14px;
  color: #bfbfbf;
  margin: 0;
`;

export const ScanList = styled.div`
  flex: 1;
  overflow-y: auto;
  padding: 24px;
`;

export const ScanItem = styled.div<{ $status: 'pending' | 'success' | 'error' }>`
  padding: 9px;
  border-radius: 6px;
  border: 2px solid ${(props) => (props.$status === 'success' ? '#b7eb8f' : props.$status === 'error' ? '#ffa39e' : '#d9d9d9')};
  background-color: ${(props) => (props.$status === 'success' ? '#f6ffed' : props.$status === 'error' ? '#fff1f0' : '#fafafa')};
  margin-bottom: 8px;
  transition: all 0.3s;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const ScanItemContent = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
`;

export const ScanItemLeft = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex: 1;
  min-width: 0;
`;

export const ScanNumber = styled.div<{ $status: 'pending' | 'success' | 'error' }>`
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  background-color: ${(props) => (props.$status === 'success' ? '#b7eb8f' : props.$status === 'error' ? '#ffa39e' : '#d9d9d9')};
  color: ${(props) => (props.$status === 'success' ? '#389e0d' : props.$status === 'error' ? '#cf1322' : '#595959')};
`;

export const ScanInfo = styled.div`
  flex: 1;
  min-width: 0;
`;

export const ScanCode = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 3px;
`;

export const ScanCodeText = styled.p`
  font-family: 'Courier New', monospace;
  font-size: 20px;
  font-weight: 700;
  color: #262626;
  margin: 0;
  word-break: break-all;
`;

export const ScanTime = styled.p`
  font-size: 11px;
  color: #8c8c8c;
  margin: 0;
`;

export const ScanError = styled.div`
  margin-top: 6px;
  display: flex;
  align-items: flex-start;
  gap: 6px;
  padding: 6px;
  background-color: #ffccc7;
  border-radius: 4px;
`;

export const ScanErrorText = styled.p`
  font-size: 11px;
  color: #a8071a;
  margin: 0;
  flex: 1;
`;

export const ScanTrackCode = styled.div`
  flex-shrink: 0;
  text-align: right;
`;

export const ScanTrackCodeText = styled.p`
  font-family: 'Courier New', monospace;
  font-size: 13px;
  font-weight: 500;
  color: #1890ff;
  margin: 0;
`;

export const ScanFooter = styled.div`
  padding: 16px 24px;
  border-top: 1px solid #e8e8e8;
  background-color: #fafafa;
`;

export const ScanFooterContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
`;

export const ScanFooterLabel = styled.span`
  color: #595959;
`;

export const ScanFooterValue = styled.span`
  font-weight: 600;
  color: #262626;
`;

export const RetryButton = styled.button`
  margin-top: 6px;
  padding: 3px 6px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background-color: #fff;
  font-size: 11px;
  color: #595959;
  cursor: pointer;
  transition: all 0.3s;

  &:hover {
    border-color: #40a9ff;
    color: #40a9ff;
  }
`;
